<template lang="pug">
  .component-client-topup
    ActionBar
      h2(slot="title") Top Ups


    base-list(:component="component", :dataLoader="dataLoader", :resultsPerPage="5", componentType="client-invoices")


</template>

<script>
    import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
    import BaseList from '../../../pages/backoffice/BaseList'
    import ActionBar from '../../structure/ui/ActionBar'

    export default {
        name: 'ClientTopUps',
        components: {ActionBar, BaseList},
        data() {
            return {
                component: require('../TopUp')
            }
        },
        methods: {
            dataLoader(callback, page = 1, resultsPerPage = 5) {
                KeplerBackofficeSdk.topUps.list.all(this.$route.params.id, page, resultsPerPage, (data) => {
                    callback(data)
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ClientTopUps.vue?ef29955c